export { MwDateRangePickerModule } from './date-range-picker.module';
export { MwDateRangePickerComponent } from './date-range-picker.component';
export {
  DateRangePickerLocaleConfig as LocaleConfig,
  MW_DATE_RANGE_PICKER_LOCALE_CONFIG as LOCALE_CONFIG,
  DefaultDateRangePickerLocaleConfig as DefaultLocaleConfig,
} from './@models/date-range-picker.locale-config';
export { MwDateRangePickerLocaleService as LocaleService } from './date-range-picker-locale.service';
